export const redirectTo = (result: SearchListItems): string => {
  const { containerDisplayName, containerRef } = result;
  switch (containerDisplayName) {
    case "Quote":
      return `/applications/${containerRef}`;
    case "Policy":
      return `/policies/${containerRef}`;
    case "Claim":
      return `/claims/${containerRef}`;
    case "Customer":
      return `/customers/${containerRef}`;
    case "Transaction":
      return `/policies/${containerRef}`;
    default:
      return "";
  }
};
